
import { useState, useEffect } from "react"
import { supabase } from "../../utils/supabaseClient"
import { useRouter } from 'next/router'
import { LockClosedIcon } from '@heroicons/react/solid'
import Image from "next/image"
import Link from "next/link"
import * as ga from '../../lib/gtag'

export default function RegisterComponent (props) {
    let tz = Intl.DateTimeFormat().resolvedOptions().timeZone ? Intl.DateTimeFormat().resolvedOptions().timeZone : "America/Los_Angeles"
    const [form, setForm] = useState({"name":null, "account_type": "business", "email": "", 'password': null, 'confirm_password':null})
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState({emailInvalid:null, passwordInvalid:null, nameInvalid:null})
    const [emailError, setEmailError] = useState(null)
    const route = useRouter()
    useEffect (()=> {
        if (route.query){
            let newForm = {...form}
            newForm.email = route.query.email
            setForm(newForm)
        }
        if (props.guest) {
            let newForm = {...form}
            newForm.email =props.guest.email
            newForm.name = props.guest.name
            setForm(newForm)
        }
    },[route.query])
    


    const handleChange = (e) => {
        const {name, value} = e.target
        let newForm = {...form}
        newForm[name] = value
        setForm(newForm)

    }

    const checkErrors = () => {
        if (form.password !== form.confirm_password) {
            let newError = {...error}
            newError.passwordInvalid = "Passwords do not match"
            setError(newError)
            return false
        }
        if (form.password.length < 8) {
          let newError = {...error}
          newError.passwordInvalid = "Password too short"
          setError(newError)
            return false
        } 
        if (!form.name) {
          let newError = {...error}
          newError.nameInvalid = "Please enter a username"
          setError(newError)
          return false
        }

        return true
    }

    const submitRegister = async (e) => {
        e.preventDefault()
        setLoading(true)
        if (props.client && props.conversation) {
            props.setRedirect(false)
        }

        const bool = checkErrors()
        if (!bool) {
            setLoading(false)
            return
        }

        const { user, error } = await supabase.auth.signUp({
            email: form.email,
            password: form.password,
          })


        if (!error) {
            ga.event({
              action:'affiliate_register',
            })

            const rand = (Math.random() + 1).toString(36).substring(7)
            let payload = {user_id:user.id, name:form.name, account_type:form.account_type, email: form.email, unique_slug: rand, timezone: tz }
            if (props.client) {
                payload.account_type = "client"
            } else if (props.account_type === "affiliate") {
              payload.account_type = "affiliate"
            }
            const profile = await supabase
                .from("main_profile")
                .insert(payload)
            
              if (props.conversation) {
               //if convo add profile to convo
                  const convo = await supabase
                  .from("main_conversation")
                  .update({client_profile_id: profile.data[0].id})
                  .match({uuid: props.conversation})
              }


            //send email 
            if (props.account_type !== "affiliate") {
              await fetch("/api/contact/register", {
                method: "POST",
                headers: {'Content-Type': 'application/json'},
                body:JSON.stringify({
                  email: form.email,
                  client: props.client ? true : false,
                  brand_logo : props.brand_logo ? props.brand_logo : null,
                  coach_name: props.coach_name ? props.coach_name : null,
                })
              })
           
              if (props.conversation) {
                  route.push(`/dashboard?convo=${props.conversation}`)
              }
              route.push(`/dashboard`)

            } else {
              route.push(`/affiliate`)
            }
          
           

            
        } else {
            setEmailError(error.message)
        }

    }
    return (

      <div className=" flex  justify-center pb-12 px-4 sm:px-6 lg:px-8 ">
        <div className="max-w-md w-full space-y-8">

          <form className="mt-8 space-y-6" action="#" method="POST">
            {/* <input type="hidden" name="remember" defaultValue="true" /> */}
            <div className="shadow-sm  rounded-md -space-y-px">
            <div>
                <label htmlFor="name" className="sr-only">
                    Name
                </label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  required
                  className={`${error.nameInvalid ? ' border-pink-500' : 'border-gray-300 placeholder-gray-500 '} z-10 text-gray-900 appearance-none  relative block w-full px-3 py-2 border rounded-t-md focus:outline-none focus:ring-zinc-500 focus:border-zinc-500 focus:z-10 sm:text-sm`}
                  placeholder="Name"
                  onChange={handleChange}
                />
              </div>
              <div>
                <label htmlFor="email-address" className="sr-only">
                  Email address
                </label>
                <input
                  id="email-address"
                  name="email"
                  type="email"
                  defaultValue={form.email}
                  autoComplete="email"
                  required
                  className={`${error.emailInvalid ? ' border-pink-500 text-pink-600' : 'border-gray-300 placeholder-gray-500 text-gray-900'}  appearance-none  relative block w-full px-3 py-2 border focus:outline-none focus:ring-zinc-500 focus:border-zinc-500 focus:z-10 sm:text-sm`}
                  placeholder="Email address"
                  onChange={handleChange}
                />
              </div>
              <div>
                <label htmlFor="password" className="sr-only">
                  Password
                </label>
                <input
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  required
                  className={`${error.passwordInvalid ? ' invalid:border-pink-500 invalid:text-pink-600' : 'border-gray-300 placeholder-gray-500 text-gray-900'}  shadow-sm  appearance-none relative block w-full px-3 py-2 border   focus:outline-none focus:ring-zinc-500 focus:border-zinc-500 focus:z-10 sm:text-sm`}
                  placeholder="Password"
                  onChange={handleChange}
                />
              </div>
              <div>
                <label htmlFor="password" className="sr-only">
                  Password
                </label>
                <input
                  id="confirm_password"
                  name="confirm_password"
                  type="password"
                  autoComplete="current-password"
                  required
                  className={`${error.passwordInvalid ? ' invalid:border-pink-500 invalid:text-pink-600' : 'border-gray-300 placeholder-gray-500 text-gray-900'}  shadow-sm  appearance-none relative block w-full px-3 py-2 border  rounded-b-md focus:outline-none focus:ring-zinc-500 focus:border-zinc-500 focus:z-10 sm:text-sm`}
                  placeholder="Confirm Password"
                  onChange={handleChange}
                />
              </div>
            </div>
            {error.nameInvalid &&<span className="block text-pink-600">{error.nameInvalid}</span>}
            {error.passwordInvalid &&<span className="block text-pink-600">{error.passwordInvalid}</span>}
            {error.emnailInvalid &&<span className="block text-pink-600">{error.emnailInvalid}</span>}


            <div>
            <span className="text-muted" style={{fontSize:'13px'}}>By registering for a Plaza account, you agree to our <Link href="/terms-conditions"><a className="underline underline-4">terms and conditions</a></Link></span>
              <button
                onClick={submitRegister}
                disabled={loading}
                type="submit"
                className="group relative w-full flex mt-2 justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-zinc-900 hover:bg-zinc-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-zinc-500"
              >
                <span className="absolute left-0 inset-y-0 flex items-center pl-3">
                  <LockClosedIcon className="h-5 w-5 text-zinc-500 group-hover:text-zinc-400" aria-hidden="true" />
                </span>
                { loading ? 
                 <svg className="animate-spin ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg> 
                : 
                'Register'}
              </button>
            </div>
          </form>
        </div>
      </div>

            
    )
}